// In your constants file (e.g., constants/index.js)
import { images } from '../constants'; // Upewnij się, że masz zaimportowane obrazy

export const training = [ 
    {
        id: 1,
        title: "Ogród, który wspiera dobrostan",
        subtitle: "Jak projektować ogrody, które nie tylko wyglądają efektownie, ale realnie poprawiają jakość życia użytkowników i sprzedają się łatwiej?",
        image: images.training1, 

        // Kluczowe szczegóły do Sidebara
        details: {
            duration: '2 dni (8h szkoleniowych)',
            level: 'Specjalistyczny',
            deadline: 'Zapisy otwarte',
        },

        goals: [
            "Pogłębienie wiedzy o tym, jak ogród wpływa na zdrowie psychiczne, poczucie dobrostanu i motywację do działania.",
            "Przekład wyników badań z psychologii i neurobiologii na konkretne decyzje projektowe.",
            "Poznanie i praktyczne zastosowanie wzorców projektowania Christophera Alexandra w odniesieniu do ogrodów i terenów zielonych.",
            "Rozwinięcie umiejętności diagnozowania potrzeb klienta oraz komunikowania projektu w sposób zrozumiały, atrakcyjny i budujący zaufanie."
        ],

        outcomes: [
            "są lepiej dopasowane do użytkowników,",
            "wspierają ich dobrostan,",
            "wyróżniają się na rynku jako „ogrody do życia”, a nie tylko „do oglądania”."
        ],

        targetAudience: [
            "projektantów ogrodów i terenów zielonych,",
            "wykonawców ogrodów,",
            "architektów krajobrazu,",
            "osób zajmujących się pielęgnacją ogrodów,",
            "wszystkich, którzy chcą wzbogacić swoje projekty o aspekt psychologiczny i lepiej współpracować z klientem."
        ],

        program: [
            {
                title: "1. Ogród jako prywatne „centrum dobrostanu” – co mówi nauka? Przegląd najważniejszych badań:",
                points: [
                    "jak kontakt z zielenią wpływa na stres, koncentrację, regenerację psychiczną,",
                    "dlaczego nawet mały ogród może pełnić funkcję „mikro-sanatorium”,",
                    "jakie cechy ogrodu (układ, zieleń, woda, miejsca do siedzenia) realnie wspierają dobrostan, a co jest tylko modą z Instagrama,",
                    "co z tego wynika dla projektanta i wykonawcy: argumenty, które działają na klientów (także biznesowych i instytucjonalnych)."
                ]
            },
            {
                title: "2. Diagnoza potrzeb klienta – jak odkryć to, czego on sam nie umie nazwać?",
                points: [
                    "Różnica między „chcę tu trawnik i lawendę” a prawdziwą potrzebą użytkową i emocjonalną.",
                    "Struktura rozmowy z klientem: pytania o styl życia, nawyki, rytm dnia, jak wydobywać informacje o emocjach i skojarzeniach związanych z ogrodem.",
                    "Prosty, gotowy do użycia „kwestionariusz potrzeb ogrodowych” – narzędzie, które możesz od razu wdrożyć w swojej praktyce.",
                    "Jak radzić sobie z „trudnym” klientem: niespójne oczekiwania, ograniczony budżet, brak decyzji."
                ]
            },
            {
                title: "3. Jak prezentować projekt, żeby klient go zrozumiał i… zapragnął?",
                points: [
                    "Typowe błędy w komunikowaniu projektu (zbyt techniczny język, nadmiar detali, niezrozumiałe rzuty).",
                    "Jak opowiadać o projekcie w sposób: obrazowy (język korzyści, scenki z życia w ogrodzie), psychologiczny („tu będzie miejsce na wyciszenie, tu na spotkania”), sprzedażowy (pokazujący wartość, nie tylko cenę).",
                    "Narzędzia komunikacji: wizualizacje, plansze moodboard, krótkie opisy – co naprawdę robi różnicę w oczach klienta.",
                    "Jak bronić odważnych rozwiązań („dlaczego nie robię ogrodów z samą kostką i tujami?”) w oparciu o konkretne argumenty naukowe i funkcjonalne."
                ]
            },
            {
                title: "4. Psychologia w projektowaniu ogrodu – warsztat praktyczny",
                points: [
                    "Ćwiczenia na realnych lub przykładowych przypadkach: Tworzenie „persony użytkownika ogrodu” – profil psychologiczny i styl życia.",
                    "Projektowanie ścieżki użytkownika: jak człowiek „czyta” przestrzeń, gdzie się zatrzymuje, gdzie czuje się bezpiecznie, a gdzie nieswojo.",
                    "Mapa nastrojów w ogrodzie: strefy wyciszenia, zabawy, pracy, kontaktu z naturą, jak równoważyć je w małej i dużej przestrzeni.",
                    "Mini-korekta projektów uczestników (jeśli uczestnicy przyniosą swoje koncepcje) pod kątem doświadczenia użytkownika i psychologii."
                ]
            },
            {
                title: "5. Wzorce projektowania Christophera Alexandra w ogrodzie i terenach zielonych",
                points: [
                    "Krótkie wprowadzenie do koncepcji „A Pattern Language” – dlaczego te wzorce są tak uniwersalne i ponadczasowe.",
                    "Najważniejsze wzorce przydatne w projektowaniu ogrodów i zieleni (omówione na przykładach): „Próg”, „Miejsce przy oknie”, „Ogród przy kuchni”, „Sieć ogrodów”, „Ciche zakątki” i „Miejsca spotkań”.",
                    "Jak przekładać wzorce Alexandra na: małe przydomowe ogrody, większe założenia zieleni przy inwestycjach, przestrzenie półpubliczne.",
                    "Ćwiczenie: wspólne stworzenie „języka wzorców” dla przykładowego ogrodu."
                ]
            }
        ],

        methods: [
            "Krótkie wprowadzenia teoretyczne oparte na aktualnych badaniach",
            "Analiza przykładów z praktyki projektowej",
            "Ćwiczenia indywidualne i w małych grupach",
            "Dyskusja, wymiana doświadczeń, sesja pytań i odpowiedzi"
        ]
    },
    {
        id: 2,
        title: "Zarządzanie nasadzeniami naturalistycznymi",
        subtitle: "W Ogrodzie Botanicznym i przestrzeni publicznej: jak łączyć estetykę, biologię i realia utrzymaniowe.",
        image: images.training2,

        details: {
            duration: '1 dzień (6–7h) lub 2x4h',
            level: 'Zaawansowany',
            deadline: 'Zapisy otwarte',
        },

        goals: [
            "Nauka projektowania i wdrażania nasadzeń naturalistycznych, które są botanicznie poprawne.",
            "Zrozumienie jak tworzyć kompozycje estetyczne przez wiele lat, a nie tylko w momencie sadzenia.",
            "Optymalizacja projektów pod kątem utrzymania przy realnych budżetach i dostępnych kadrach.",
            "Identyfikacja i eliminacja gatunków inwazyjnych oraz problemowych („znikających” po kilku sezonach).",
            "Wykorzystanie ogrodu botanicznego jako wzorca dla zieleni miejskiej."
        ],

        outcomes: [
            "są oparte na jasnych kryteriach doboru roślin do siedliska,",
            "posiadają silne argumenty merytoryczne do rozmów z inwestorem i dyrekcją,",
            "są możliwe do utrzymania bez generowania nadmiernych kosztów,",
            "wykorzystują profesjonalny język fachowy połączony z narracyjnym."
        ],

        targetAudience: [
            "architektów krajobrazu,",
            "ogrodników miejskich,",
            "kuratorów kolekcji i zarządców zieleni,",
            "projektantów zieleni,",
            "osób szukających kompromisu między estetyką a biologią w przestrzeni publicznej."
        ],

        program: [
            {
                title: "1. Dobór roślin do siedliska – decyzje, nie katalogi",
                points: [
                    "Analiza gleby, ekspozycji i wody jako podstawa sukcesu.",
                    "Rośliny trwałe vs. efektowne – jak znaleźć balans.",
                    "Gatunki, które „znikają” po 3 latach – dlaczego tak się dzieje i czym je zastąpić.",
                    "Rośliny trudne i problemowe w nasadzeniach publicznych: co eliminować, a co kontrolować."
                ]
            },
            {
                title: "2. Struktura nasadzeń naturalistycznych",
                points: [
                    "Warstwowość w praktyce: cebule, byliny, trawy, rośliny podporowe.",
                    "Rytm, powtarzalność, punkty ciężkości – zasady kompozycji.",
                    "Jak uniknąć efektu „zielonej masy bez charakteru”.",
                    "Tworzenie nasadzeń, które wyglądają dobrze o każdej porze roku."
                ]
            },
            {
                title: "3. Rośliny cebulowe w kolekcjach i nasadzeniach trwałych",
                points: [
                    "Naturalizacja cebul w trawnikach i runie – jak to zrobić skutecznie.",
                    "Zarządzanie zanikiem i ekspansją roślin cebulowych.",
                    "Kiedy nie sadzić cebul (i dlaczego) – najczęstsze błędy inwestycyjne."
                ]
            },
            {
                title: "4. Pielęgnacja bez niszczenia koncepcji",
                points: [
                    "Techniki koszenia, cięcia i usuwania biomasy w ogrodach naturalistycznych.",
                    "Kalendarz prac dla zespołów technicznych – jak planować zadania w czasie.",
                    "Błędy wynikające z „estetyki porządkowej” – jak edukować ekipy utrzymaniowe."
                ]
            },
            {
                title: "5. Spacer ekspercki po ogrodzie botanicznym (lub analiza Case Study)",
                points: [
                    "Analiza istniejących nasadzeń w terenie.",
                    "Wskazanie konkretnych błędów projektowych i wykonawczych.",
                    "Prezentacja rozwiązań alternatywnych.",
                    "Dyskusja na realnych przykładach z pracy uczestników."
                ]
            }
        ],

        methods: [
            "Wykład z prezentacją multimedialną",
            "Analiza przypadków (Case Study)",
            "Spacer ekspercki (analiza nasadzeń w terenie)",
            "Dyskusja problemowa i wymiana doświadczeń"
        ]
    }
];

export default training;